<template>
  <b-modal
    id="modal-tutorial-devolucao"
    :title="null"
    size="lg"
    hide-footer
    centered
    hide-header
    scrollable
    body-class="p-0"
  >
    <div class="tut">
      <!-- Header -->
      <div class="tut__header">
        <div class="tut__header-icon">
          <feather-icon icon="BookOpenIcon" size="26" />
        </div>
        <div class="tut__header-info">
          <div class="tut__title">Guia de Devolução</div>
          <div class="tut__subtitle">Passo a passo e regras para devolução de produtos</div>
        </div>
        <b-button
          variant="flat-light"
          size="sm"
          class="tut__close"
          @click="$bvModal.hide('modal-tutorial-devolucao')"
        >
          <feather-icon icon="XIcon" size="18" />
        </b-button>
      </div>

      <div class="tut__body">
        <!-- Passo a passo -->
        <h6 class="tut__section-title">
          <feather-icon icon="ListIcon" size="15" class="mr-50" /> Passo a passo
        </h6>
        <img
          :src="passoAPassoImg"
          alt="Devolução de produtos — passo a passo"
          class="tut__passo-img"
        />

        <!-- Período e condições -->
        <h6 class="tut__section-title">
          <feather-icon icon="CalendarIcon" size="15" class="mr-50" /> Período e condições
        </h6>
        <div class="tut__callout tut__callout--info">
          <ul class="tut__list">
            <li>Apenas produtos em <strong>perfeito estado</strong>.</li>
            <li>Pedidos efetuados entre <strong>01/09/2025</strong> e <strong>31/03/2026</strong>.</li>
            <li>
              Devolução considerando produto entregue até <strong>08/05/2026</strong> no armazém (LUFT),
              com nota fiscal emitida entre <strong>01/04/2026</strong> e <strong>30/04/2026</strong>.
            </li>
          </ul>
        </div>

        <!-- O que a NF deve conter -->
        <h6 class="tut__section-title">
          <feather-icon icon="FileTextIcon" size="15" class="mr-50" /> O que a Nota Fiscal deve conter
        </h6>
        <ul class="tut__check">
          <li v-for="(item, i) in itensNf" :key="i">
            <feather-icon icon="CheckIcon" size="14" class="tut__check-icon" />
            <span v-html="item"></span>
          </li>
        </ul>

        <!-- Destinatário e endereço -->
        <h6 class="tut__section-title">
          <feather-icon icon="MapPinIcon" size="15" class="mr-50" /> Destinatário e endereço de entrega
        </h6>
        <div class="tut__callout tut__callout--address">
          <div class="tut__addr-line">
            <span class="tut__addr-label">Destinatário</span>
            <strong>MACMILLAN DO BRASIL</strong> — CNPJ 74.479.577/0002-45
          </div>
          <div class="tut__addr-line">
            <span class="tut__addr-label">Entrega (campo "observação" da NF)</span>
            <span>
              LUFT TRANSPORTES RODOVIÁRIOS E ARMAZÉNS GERAIS LTDA<br>
              Centro Logístico Cajamar — Via de Acesso Norte Km 38, 420, Galpão 01<br>
              Bloco 7ª Empresarial Gato Preto (Jordanésia)<br>
              Cajamar / SP — CEP: 07789-100
            </span>
          </div>
        </div>

        <!-- Envio do XML -->
        <h6 class="tut__section-title">
          <feather-icon icon="MailIcon" size="15" class="mr-50" /> Envio do XML (antes de despachar)
        </h6>
        <p class="tut__p">
          Envie o arquivo <strong>XML</strong> (arquivo digital e PDF da NF-e) por e-mail para:
        </p>
        <div class="tut__emails">
          <a v-for="email in emails" :key="email" :href="`mailto:${email}`" class="tut__email">
            <feather-icon icon="AtSignIcon" size="13" class="mr-25" />{{ email }}
          </a>
        </div>

        <!-- Entrega na LUFT -->
        <h6 class="tut__section-title">
          <feather-icon icon="TruckIcon" size="15" class="mr-50" /> Entrega na LUFT
        </h6>
        <div class="tut__callout tut__callout--success">
          Ao receber o e-mail de <strong>validação da devolução</strong>, efetue a entrega
          <strong>sem agendamento</strong> na LUFT, de <strong>segunda a sexta-feira, das 8h às 16h</strong>.
        </div>

        <!-- Observações importantes -->
        <h6 class="tut__section-title">
          <feather-icon icon="AlertTriangleIcon" size="15" class="mr-50" /> Observações importantes
        </h6>
        <div class="tut__callout tut__callout--warning">
          <ul class="tut__list">
            <li>
              Produtos <strong>danificados</strong> ou quantidades <strong>faltantes</strong> serão faturados
              via boleto bancário (prazo de 15 dias). Sobras ficam disponíveis por 7 dias corridos na LUFT;
              após esse prazo são destinadas a aparas. O frete de produtos danificados é de responsabilidade do cliente.
            </li>
            <li>
              Os <strong>créditos</strong> das devoluções poderão abater títulos em aberto somente após a
              <strong>conferência física</strong> pela equipe logística.
            </li>
          </ul>
        </div>

        <!-- Contato -->
        <div class="tut__contact">
          <feather-icon icon="PhoneCallIcon" size="16" class="mr-50" />
          <span>
            Dúvidas? Fale com <strong>Emerson Marques</strong> ou <strong>Willians Barbosa</strong> —
            (11) 98473-1956 / (11) 99847-3278, de segunda a sexta, em horário comercial.
          </span>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import passoAPassoImg from '@/assets/images/guia-devolucao-passo-a-passo.png';

export default {
  name: 'ModalTutorialDevolucao',
  data() {
    return {
      passoAPassoImg,
      itensNf: [
        '<strong>ISBN</strong> do(s) produto(s).',
        'No campo <strong>"código EAN"</strong>, preencher o código de barras EAN (ISBN) dos produtos.',
        '<strong>Descrição</strong> do(s) produto(s).',
        '<strong>Quantidade</strong> de cada produto devolvido.',
        'Valor de aquisição do(s) produto(s) — deve ser igual ao da NF de origem.',
        'Número da <strong>NF</strong> que originou a venda do produto devolvido.',
        'Destinatário e endereço de entrega corretos (ver abaixo).',
      ],
      emails: [
        'emerson.marques@macmillaneducation.com',
        'willians.barbosa@macmillaneducation.com',
        'antonielly.barbosa@macmillaneducation.com',
        'recebimentofacil@springernature.com',
      ],
    };
  },
};
</script>

<style scoped>
.tut {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 3.5rem);
}
.tut__header {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 22px 24px;
  background: linear-gradient(135deg, #ea5455 0%, #b83b3c 100%);
  color: #fff;
  flex-shrink: 0;
}
.tut__header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.18);
}
.tut__title {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.2;
}
.tut__subtitle {
  font-size: 0.85rem;
  opacity: 0.92;
  margin-top: 2px;
}
.tut__close {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #fff !important;
  padding: 4px;
}
.tut__body {
  padding: 20px 24px 24px;
  flex: 1 1 auto;
  overflow-y: auto;
}
.tut__section-title {
  font-weight: 600;
  margin: 22px 0 12px;
  display: flex;
  align-items: center;
  opacity: 0.85;
}
.tut__section-title:first-child {
  margin-top: 0;
}

/* Passo a passo (imagem) */
.tut__passo-img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.dark-layout .tut__passo-img {
  background: #fff;
  border-color: rgba(255, 255, 255, 0.12);
}

/* Callouts */
.tut__callout {
  padding: 14px 16px;
  border-radius: 10px;
  font-size: 0.88rem;
  border-left: 4px solid #7367f0;
  background: rgba(115, 103, 240, 0.07);
}
.tut__callout--info { border-left-color: #00cfe8; background: rgba(0, 207, 232, 0.07); }
.tut__callout--success { border-left-color: #28c76f; background: rgba(40, 199, 111, 0.08); }
.tut__callout--warning { border-left-color: #ff9f43; background: rgba(255, 159, 67, 0.08); }
.tut__callout--address { border-left-color: #ea5455; background: rgba(234, 84, 85, 0.06); }

.tut__list {
  margin: 0;
  padding-left: 18px;
}
.tut__list li + li { margin-top: 6px; }

/* Checklist */
.tut__check {
  list-style: none;
  margin: 0;
  padding: 0;
}
.tut__check li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 7px 0;
  font-size: 0.88rem;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.08);
}
.tut__check li:last-child { border-bottom: none; }
.tut__check-icon {
  flex-shrink: 0;
  margin-top: 2px;
  color: #28c76f;
}

/* Address */
.tut__addr-line + .tut__addr-line { margin-top: 12px; }
.tut__addr-label {
  display: block;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  opacity: 0.6;
  margin-bottom: 2px;
}

/* Emails */
.tut__p { font-size: 0.88rem; margin-bottom: 8px; }
.tut__emails {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.tut__email {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 0.82rem;
  font-weight: 500;
  background: rgba(115, 103, 240, 0.1);
  color: #7367f0;
  text-decoration: none;
}
.tut__email:hover { background: rgba(115, 103, 240, 0.18); }

/* Contact */
.tut__contact {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 24px;
  padding: 14px 16px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.03);
  font-size: 0.86rem;
}

/* Dark mode tweaks */
.dark-layout .tut__check li { border-bottom-color: rgba(255, 255, 255, 0.08); }
.dark-layout .tut__contact { background: rgba(255, 255, 255, 0.05); }
</style>
